module.exports = __webpack_public_path__ + "static/media/logo3.02cfc800.png";